// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userinfo-username[data-v-035a032a],\n.userinfo-userdept[data-v-035a032a] {\n  font-size: 1.1em;\n  font-weight: 500;\n}\n.text-usersetting[data-v-035a032a] {\n  text-align: center;\n  height: 30px !important;\n}\n.text-userinfo[data-v-035a032a] {\n  text-align: center;\n  border-bottom: 1px solid #dddddd;\n  padding-top: 30px !important;\n  height: 80px !important;\n}\n.userinfo-close[data-v-035a032a] {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
